import React, { useContext } from 'react'
import emptyState from '../../../../assets/images/dashboard/empty-state.png'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import Image from 'react-bootstrap/Image'
import styled from 'styled-components'
import { JazeelContext } from '../../../utils/JazeelContext'

const RecommendationContainer = styled(Card)`
  border-radius: 0 10px 10px 0;
  background-color: #ffffff;
  border: none;
  box-shadow: -16px 1px 20px rgba(0, 0, 0, 0.1);
`
const CardHeader = styled.p`
  font-weight: bold;
  font-size: 1.063em;
`
const ImageContainer = styled.small`
  text-align: center;
  display: block;
`
export default function RecommendationCard() {
  const { userData } = useContext(JazeelContext)
  return (
    <Col lg={8}>
      <RecommendationContainer className="h-100">
        <Card.Body>
          <CardHeader>{`Here is what you can do with ${userData &&
            userData.points} points`}</CardHeader>

          <ImageContainer className="text-muted">
            <Image
              src={`${emptyState}`}
              className="d-block mt-5 mb-4 mx-auto"
            />
            Coming Soon.
          </ImageContainer>
        </Card.Body>
      </RecommendationContainer>
    </Col>
  )
}
